import React, { type FC, useMemo } from 'react'
import { Box, Paper, Stack, type SxProps, type Theme, Typography } from '@mui/material'

import { Translation } from '../../../domain'

import { Background, CybusCompleteLogo } from '../common'
import { FormattedTranslation } from '../Internationalization'
import { useAppUsecase } from '../State'
import { LoginForm } from './LoginForm'

const Version: FC = () => {
    const usecase = useAppUsecase('versionUsecase')
    const version = useMemo(() => usecase.getUIVersion(), [usecase])

    return (
        <Typography data-testid="connectware-version" variant="body2" color="white">
            <FormattedTranslation id={Translation.VERSION} /> {version}
        </Typography>
    )
}

const wrapperStyle: SxProps<Theme> = { height: '100vh' }
const leftSideStyle: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 480,
    /**
     * The only leftover of legacyPrimary color
     * @see https://cybusio.atlassian.net/browse/CC-4512
     */
    backgroundColor: '#0e507a',
    flexBasis: 'min-content',
}
const logoWrapperStyle: SxProps<Theme> = { p: 6, px: 20 }
const contentwrapperStyle: SxProps<Theme> = { px: 10, pb: 10, height: '100%' }
const backgroundStyle: SxProps<Theme> = { width: '100%' }

export const Wrapper: FC = () => (
    <Stack direction="row" sx={wrapperStyle}>
        <Paper sx={leftSideStyle} square>
            <Box sx={logoWrapperStyle}>
                <CybusCompleteLogo />
            </Box>
            <Stack sx={contentwrapperStyle} justifyContent="space-between" direction="column">
                <Typography data-testid="connectware-slogan" variant="h3" color="white">
                    <FormattedTranslation id={Translation.CONNECTWARE_SLOGAN} />
                </Typography>
                <LoginForm />
                <Version />
            </Stack>
        </Paper>
        <Box sx={backgroundStyle}>
            <Background />
        </Box>
    </Stack>
)
